<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Retención {{ form.numero_comprobante }}</h3>
        <label>
          <div v-show="anulado === 'S'" class="noti-danger">
            <strong>ANULADO</strong>
          </div>
          <div v-show="estado === 'A' && anulado === 'N'" class="noti-success">
            <strong>AUTORIZADO</strong>
          </div>
          <div
            v-show="estado === 'N' && anulado === 'N'"
            class="noti-secondary"
          >
            <strong>NUEVO</strong>
          </div>
        </label>
      </div>
      <div class="layout__controls">
        <button
          :disabled="!permiteAnularRetencion && !permiteEditarRetencion"
          @click="consultarComprobantes"
          class="btn-info btn--bigger"
          type="button"
        >
          <i class="fa fa-search"></i>
          <span>Buscar comprobantes</span>
        </button>
        <modal width="85%" height="auto" scrollable name="listaComprobantes">
          <lista-comprobantes-compra
            @selected="selectedComprobante"
            :tipoComprobante="tipoComprobante"
          ></lista-comprobantes-compra>
        </modal>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información de la retención</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-inline">
                  <label for="manual">
                    <input
                      :disabled="!editable || form.mybillbot"
                      v-model="form.tipo"
                      value="M"
                      type="radio"
                      id="manual"
                    />
                    <span>Manual</span>
                  </label>
                  <label for="electronico">
                    <input
                      :disabled="!editable || form.mybillbot"
                      v-model="form.tipo"
                      value="E"
                      type="radio"
                      id="electronico"
                    />
                    <span>Electrónico</span>
                  </label>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <label for="mybillbot">
                    <input
                      disabled
                      v-model="form.mybillbot"
                      type="checkbox"
                      id="mybillbot"
                    />
                    <span>Importado por MyBillBot</span>
                  </label>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-field">
                    <div class="form-group">
                      <input-field
                        readonly
                        v-model="form.numero_comprobante_afectado"
                        type="tel"
                        v-mask="'###-###-#########'"
                        id="comprobanteAfectado"
                        placeholder="N° comprobante"
                      >
                        <span>Comprobante afectado</span>
                      </input-field>
                      <modal
                        width="85%"
                        height="auto"
                        scrollable
                        name="comprobantesAfectados"
                      >
                        <lista-comprobantes
                          @selected="selectedComprobanteAfectado"
                          :tipoComprobante="codigoFactura"
                        ></lista-comprobantes>
                      </modal>
                      <button
                        @click="consultarComprobantesVenta"
                        v-show="
                          form.id_tipo_comprobante_afectado === '' &&
                          estado === 'N'
                        "
                        class="btn-info"
                        type="button"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                      <button
                        @click="quitarComprobanteAfectado"
                        v-show="
                          form.id_tipo_comprobante_afectado !== '' &&
                          estado === 'N'
                        "
                        class="btn-danger"
                      >
                        <i class="fa fa-ban"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <VueCtkDateTimePicker
                      :disabled="!editable || form.mybillbot"
                      id="fecha_emision_comprobante_afectado"
                      v-model="form.fecha_emision_comprobante_afectado"
                      locale="es"
                      no-label
                      only-date
                      auto-close
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD"
                      formatted="YYYY-MM-DD"
                      label="Seleccione una fecha..."
                    />
                    <label>Fecha de emisión del comprobante</label>
                    <span
                      v-if="errores.fecha_emision_comprobante_afectado"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{
                        errores.fecha_emision_comprobante_afectado[0]
                      }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <input-field
                  :disabled="!editable || form.mybillbot"
                  v-mask="'###-###-#########'"
                  id="numeroDocumento"
                  placeholder="###-###-#########"
                  v-model="form.numero_comprobante"
                >
                  Número de documento
                  <span
                    v-if="errores.numero_comprobante"
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{ errores["numero_comprobante"][0] }}</strong>
                  </span>
                </input-field>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <input-field
                    v-model="form.identificacion_cliente"
                    readonly
                    id="identificacion"
                    placeholder="# Identificación"
                  >
                    Identificación *
                    <span
                      v-if="errores.id_cliente"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.id_cliente[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-group">
                    <input-field
                      v-model="form.nombre_cliente"
                      readonly
                      id="cliente"
                      placeholder="Nombre de cliente"
                    >
                      <span>Cliente *</span>
                    </input-field>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <VueCtkDateTimePicker
                      :disabled="form.mybillbot"
                      id="fecha_emision"
                      v-model="form.fecha_emision"
                      locale="es"
                      no-label
                      only-date
                      auto-close
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD"
                      formatted="YYYY-MM-DD"
                      label="Seleccione una fecha..."
                    />
                    <label for="fecha_emision"
                      >Fecha de emisión (retención)</label
                    >
                    <span
                      v-if="errores.fecha_emision"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.fecha_emision[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    vMoney
                    :format="numero"
                    :disabled="!editable || form.mybillbot"
                    v-model="form.numero_autorizacion"
                    placeholder="#############"
                    id="numero_autorizacion"
                  >
                    <span>N° Autorización</span>
                    <span
                      v-if="errores.numero_autorizacion"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.numero_autorizacion[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    vMoney
                    :format="numero"
                    :disabled="!editable || form.mybillbot"
                    :readonly="form.tipo === 'M'"
                    v-model="form.clave_acceso"
                    id="clave_acceso"
                    placeholder="################"
                  >
                    <span>Clave de acceso</span>
                    <span
                      v-if="errores.clave_acceso"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.clave_acceso[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <date-picker
                      :type="tipoFechaAutorizacion"
                      :format="formatoFechaAutorizacion"
                      :disabled="!editable || form.mybillbot"
                      v-model="form.fecha_autorizacion"
                      id="fecha_autorizacion"
                      lang="es"
                    ></date-picker>
                    <label for="fecha_autorizacion"
                      >Fecha de autorización (retención)</label
                    >
                    <span
                      v-if="errores.fecha_autorizacion"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.fecha_autorizacion[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <tabla-detalle-retencion
            venta
            :disabled="!editable || form.mybillbot"
            :codigoIva="codigoIva"
            :codigoIsd="codigoIsd"
            :codigoRenta="codigoRenta"
            :baseImponibleIsd="baseImponibleIsd"
            :baseImponibleRenta="baseImponibleRenta"
            :baseImponibleIva="baseImponibleIva"
            @input="inputDetalleRetencion"
            :impuestos="impuestos"
            :errores="errores"
            v-model="form.detalles"
            :fechaEmision="form.fecha_emision"
          ></tabla-detalle-retencion>
        </div>
        <div class="row mt-3">
          <div class="col-xs-12 col-md-6">
            <div class="card">
              <div class="card__title">
                <h5>Detalles adicionales</h5>
              </div>
              <div class="card__content">
                <tabla-informacion-adicional
                  :disabled="!editable || form.mybillbot"
                  :errores="errores"
                  v-model="form.detallesAdicionales"
                ></tabla-informacion-adicional>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="card">
              <div class="card__title">
                <h5>Totales</h5>
              </div>
              <div class="card__content">
                <div class="row">
                  <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        :value="isd"
                        readonly
                        placeholder="$ ##.##"
                        id="totalISD"
                      >
                        <span>Total ISD</span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        :value="iva"
                        readonly
                        placeholder="$ ##.##"
                        id="totalIva"
                      >
                        <span>Total IVA</span>
                      </input-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        :value="renta"
                        readonly
                        placeholder="$ ##.##"
                        id="totalRenta"
                      >
                        <span>Total Renta</span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        :value="total"
                        readonly
                        placeholder="$ ##.##"
                        id="totalRetenido"
                      >
                        <span>Total Retenido</span>
                      </input-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button
              v-show="!form.mybillbot"
              :disabled="
                (estado === 'N' && !permiteCrearRetencion) ||
                (estado !== 'N' && !permiteEditarRetencion)
              "
              @click="guardarComprobante"
              class="btn-success"
              type="button"
            >
              <i class="fa fa-save"></i>
              <span>Guardar</span>
            </button>
            <button
              :disabled="!permiteCrearRetencion"
              @click="nuevoComprobante"
              type="button"
              class="btn-light btn--text"
            >
              <i class="fa fa-plus"></i>
              <span>Nuevo</span>
            </button>
            <button
              :disabled="!permiteAnularRetencion"
              @click="anularComprobante"
              v-show="estado !== 'N' && anulado === 'N'"
              type="button"
              class="btn-danger btn--text"
            >
              <i class="fa fa-ban"></i>
              <span>Anular</span>
            </button>
            <button
              @click="imprimirComprobante"
              v-show="estado !== 'N'"
              type="button"
              class="btn-success btn--text"
            >
              <i class="fa fa-print"></i>
              <span>Imprimir</span>
            </button>
            <button @click="verAnterior" type="button" class="btn-bus300 btn--text">
              <i class="fa fa-toggle-left"></i>Anterior
            </button>
            <button @click="verSiguiente" type="button" class="btn-bus300 btn--text">
              <i class="fa fa-toggle-right"></i>Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal width="70%" name="coincidenciaComprobantes" height="auto" scrollable>
      <coincidencia-comprobantes
        @seleccionar="seleccionarComprobanteAfectado"
        @cerrar="$modal.hide('coincidenciaComprobantes')"
        :comprobantes="comprobantesConsultados"
      ></coincidencia-comprobantes>
    </modal>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      id_comprobante: "",
      form: {
        id_cliente: "",
        numero_comprobante_afectado: "",
        id_tipo_comprobante_afectado: "",
        id_tipo_comprobante: this.tipoComprobante,
        fecha_emision_comprobante_afectado: "",
        detalles: [],
        detallesAdicionales: [],
        fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
        _method: undefined,
        identificacion_cliente: "",
        nombre_cliente: "",
        numero_comprobante: "",
        numero_autorizacion: "",
        clave_acceso: "",
        fecha_autorizacion: null,
        tipo: "E",
        mybillbot: false,
      },
      url: url,
      estado: "N",
      errores: {
        id_cliente: undefined,
        numero_comprobante_afectado: undefined,
        id_tipo_comprobante_afectado: undefined,
        id_tipo_comprobante: undefined,
        fecha_emision_comprobante_afectado: undefined,
        detalles: undefined,
        detallesAdicionales: undefined,
        id_punto_emision: undefined,
        fecha_emision: undefined,
        fecha_autorizacion: undefined,
        _method: undefined,
        email: undefined,
        identificacion_cliente: undefined,
        nombre_cliente: undefined,
        numero_comprobante: undefined,
        numero_autorizacion: undefined,
        clave_acceso: undefined,
        fecha_autorizacion: undefined,
        tipo: undefined,
      },
      anulado: "N",
      comprobantesConsultados: [],
      impuestos: [],
      baseImponibleIva: null,
      baseImponibleRenta: null,
      baseImponibleIsd: null,
      money: money,
      codigoIva: "",
      codigoIsd: "",
      codigoRenta: "",
      codigoFactura: "",
      codigoRetencion: "",
      numero: numero,
    };
  },
  updated: function () {
    let that = this;
    let numeroDocumento = document.getElementById("numeroDocumento");
    if (numeroDocumento !== undefined && numeroDocumento !== null)
      numeroDocumento.onblur = function () {
        let parts = numeroDocumento.value.split("-");
        let nuevoNumero = null;
        if (parts.length === 3)
          nuevoNumero =
            parts[0] + "-" + parts[1] + "-" + parts[2].padStart(9, "0");
        else {
          nuevoNumero = numeroDocumento.value
            .replace("-", "")
            .replace("-", "")
            .padStart(15, "0");
          nuevoNumero =
            nuevoNumero.substr(0, 3) +
            "-" +
            nuevoNumero.substr(3, 3) +
            "-" +
            nuevoNumero.substr(6, 9);
        }
        that.form.numero_comprobante = nuevoNumero;
      };
  },
  props: {
    tipoComprobante: {
      required: true,
      type: String,
    },
    comprobante: {
      required: false,
      type: Object,
      default: function () {
        return null;
      },
    },
    permiteCrearRetencion: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteEditarRetencion: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteAnularRetencion: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    "form.fecha_emision": function (value) {
      if (value != null && value != undefined) {
        if (value.length == 10) {
          let date = new Date(value);
          if (date == "Invalid Date") {
            swal("Error", "La fecha de emisión es incorrecta", "error");
            this.form.fecha_emision = null;
          } else {
            date.setHours(date.getHours() + 5);
            let fechaActual = new Date();
            fechaActual.setHours(0);
            if (date > fechaActual) {
              swal("Error", "La fecha de emisión no puede ser futura", "error");
              this.form.fecha_emision = null;
            } else {
              this.validarRentaPorFecha(this.form.fecha_emision);
            }
          }
        }
      }
    },
  },
  methods: {
    verAnterior: function () {
      let urlRequest = url + '/siguiente-compra/A?tipo_comprobante=' + this.tipoComprobante + '&id_comprobante=' + this.id_comprobante;
      axios.get(urlRequest).then(({data}) => {
        if (data.idComprobante != null) {
          location.href = url + '/compras/' + data.idComprobante + '/edit';
        }
        else 
          swal('No hay documento disponible.', 'Aviso', 'warning');
      });
    },
    verSiguiente: function () {
      let urlRequest = url + '/siguiente-compra/S?tipo_comprobante=' + this.tipoComprobante + '&id_comprobante=' + this.id_comprobante;
      axios.get(urlRequest).then(({data}) => {
        if (data.idComprobante != null) {
          location.href = url + '/compras/' + data.idComprobante + '/edit';
        }
        else 
          swal('No hay documento disponible.', 'Aviso', 'warning');
      });
    },
    validarRentaPorFecha: function (date) {
      if (this.form.detalles.length == 0) return;
      let that = this;
      let urlApi = url + "/impuestos/obtener-fecha-habilitacion/" + date;
      axios.get(urlApi).then(function (response) {
        if (response.data == null) return;
        let fechaMasCercana = moment(response.data + " 00:00:00").format(
          "YYYY-MM-DD"
        );
        let fechaHabilitacion = null;
        let detalles = [];
        let valido = true;
        let eliminados = 0;
        for (let i = 0; i < that.form.detalles.length; i++) {
          valido = true;
          if (
            that.form.detalles[i].selectedTarifa != null &&
            that.form.detalles[i].selectedTarifa.id_impuesto == "1"
          ) {
            if (
              that.form.detalles[i].selectedTarifa.fecha_habilitacion != null
            ) {
              fechaHabilitacion = moment(
                that.form.detalles[i].selectedTarifa.fecha_habilitacion +
                  " 00:00:00"
              ).format("YYYY-MM-DD");
              if (fechaMasCercana != fechaHabilitacion) {
                valido = false;
                eliminados++;
              }
            }
          }
          if (valido) detalles.push(that.form.detalles[i]);
        }
        that.form.detalles = JSON.parse(JSON.stringify(detalles));
        if (eliminados > 0) {
          let mensaje =
            "Se han eliminado " +
            eliminados +
            " detalles de Renta porque la fecha de habilitación de la tarifa no coincide";
          swal("Aviso", mensaje, "warning");
        }
      });
    },
    anularComprobante: function () {
      let that = this;
      swal({
        title: "¿Desea anular este comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Anular comprobante",
        cancelButtonText: "No",
      }).then(function (result) {
        if (result.value) {
          axios
            .post(that.url + "/compras/" + that.id_comprobante, {
              _method: "DELETE",
            })
            .then(function (response) {
              that.anulado = "S";
              swal("El comprobante ha sido anulado.", "Anulado", "success");
            });
        }
      });
    },
    selectedComprobanteAfectado: function (comprobante) {
      this.form.numero_comprobante_afectado = comprobante.numero_documento;
      this.form.id_tipo_comprobante_afectado = comprobante.id_tipo_comprobante;
      this.form.id_cliente = comprobante.id_persona;
      this.form.nombre_cliente = comprobante.cliente.nombre;
      this.form.identificacion_cliente = comprobante.numero_identificacion;
      this.baseImponibleIva = parseFloat(comprobante.valor_iva);
      this.baseImponibleRenta = parseFloat(comprobante.subtotal);
      this.baseImponibleIsd = parseFloat(comprobante.subtotal);
      this.form.fecha_emision_comprobante_afectado = moment(
        new Date(comprobante.fecha_emision)
      ).format("YYYY-MM-DD");
      this.$modal.hide("comprobantesAfectados");
    },
    consultarComprobantesVenta: function () {
      this.$modal.show("comprobantesAfectados");
    },
    inputDetalleRetencion: function (value) {
      this.form.detalles = value;
    },
    seleccionarComprobanteAfectado: function (comprobante) {
      this.selectedComprobante(comprobante);
      this.$modal.hide("coincidenciaComprobantes");
    },
    nuevoComprobante: function () {
      swal({
        title: "¿Desear crear un nuevo comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Nuevo comprobante",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.form = {
            id_cliente: "",
            numero_comprobante_afectado: "",
            id_tipo_comprobante_afectado: "",
            id_tipo_comprobante: this.tipoComprobante,
            fecha_emision_comprobante_afectado: "",
            detalles: [],
            detallesAdicionales: [],
            id_punto_emision: "",
            fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
            _method: undefined,
            email: "",
            identificacion_cliente: "",
            nombre_cliente: "",
            numero_comprobante: "",
            numero_autorizacion: "",
            clave_acceso: "",
            fecha_autorizacion: null,
            tipo: "E",
            mybillbot: false,
          };
          this.estado = "N";
          this.anulado = "N";
          this.id_comprobante = "";
          this.baseImponibleIva = null;
          this.baseImponibleRenta = null;
          this.baseImponibleIsd = null;
        }
      });
    },
    imprimirComprobante: function () {
      window.open(
        this.url + "/compras/" + this.id_comprobante + "/ride",
        "_blank"
      );
    },
    cargarDatosFormulario: function () {
      let that = this;
      axios
        .get(this.url + "/compras/datos-retencion")
        .then(function (response) {
          that.impuestos = response.data.impuestos;
          that.codigoIva = response.data.codigoIva;
          that.codigoIsd = response.data.codigoIsd;
          that.codigoRenta = response.data.codigoRenta;
          that.codigoFactura = response.data.codigoFactura;
          that.codigoRetencion = response.data.codigoRetencion;
          if (that.comprobante !== null)
            that.selectedComprobante(that.comprobante);
        });
    },
    guardarComprobante: function () {
      let cantidadIva = 0;
      let cantidadIsd = 0;
      for (let i = 0; i < this.form.detalles.length; i++)
        if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoIva
        )
          cantidadIva++;
        else if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoIsd
        )
          cantidadIsd++;
      if (cantidadIva > 1 || cantidadIsd > 1) {
        swal(
          "No puede retenerse más de una vez el IVA y el ISD.",
          "Mensaje",
          "warning"
        );
        return;
      }
      this.errores = {};
      let that = this;
      let urlRequest = this.url + "/compras/retencion";
      if (that.estado !== "N") {
        urlRequest += "/" + this.id_comprobante;
        that.form._method = "PUT";
      } else that.form._method = undefined;
      axios
        .post(urlRequest, this.form)
        .then(function (response) {
          that.estado = "A";
          that.id_comprobante = response.data.id_comprobante;
          swal({
            title:
              "El comprobante fue almacenado con éxito. ¿Deseas imprimir el comprobante?",
            text: "Esta acción requiere de confirmación.",
            type: "question",
            showCancelButton: true,
            confirmButtonText: "Imprimir",
            cancelButtonText: "No",
          }).then((result) => {
            if (result.value) that.imprimirComprobante();
          });
        })
        .catch(function (error) {
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              if (response.status === 422) {
                swal(
                  "Hay errores de validación, verifique el formulario.",
                  "Error",
                  "warning"
                );
                that.errores = response.data.errors;
              } else
                swal(
                  "Hubo un error al momento de almacenar los datos, procure no repetir los detalles de retención e intente nuevamente.",
                  "Error",
                  "error"
                );
            }
          }
        });
    },
    consultarComprobanteAfectado: function () {
      if (this.form.numero_comprobante_afectado !== "") {
        let that = this;
        axios
          .get(
            this.url + "/comprobantes/" + this.form.numero_comprobante_afectado,
            {
              params: {
                tipoComprobanteAfectado: this.codigoFactura,
              },
            }
          )
          .then(function (response) {
            if (response.data.length > 0) {
              if (response.data.length === 1)
                that.selectedComprobante(response.data[0]);
              else {
                that.comprobantesConsultados = response.data;
                that.$modal.show("coincidenciaComprobantes");
              }
            } else {
              that.quitarComprobanteAfectado();
              swal(
                "No se encontró comprobantes con el número proporcionado.",
                "Mensaje",
                "warning"
              );
            }
          });
      } else
        swal("Debe ingresar un número de comprobante.", "Aviso", "warning");
    },
    quitarComprobanteAfectado: function () {
      this.form.numero_comprobante_afectado = "";
      this.form.id_tipo_comprobante_afectado = "";
      this.form.fecha_emision_comprobante_afectado = "";
      this.form.id_cliente = "";
      this.form.nombre_cliente = "";
      this.form.identificacion_cliente = "";
      this.baseImponibleIva = null;
      this.baseImponibleRenta = null;
      this.baseImponibleIsd = null;
      this.form.detalles = [];
    },
    consultarComprobantes: function () {
      this.$modal.show("listaComprobantes");
    },
    selectedComprobante: function (comprobante) {
      this.form.id_cliente = comprobante.id_persona;
      this.form.nombre_cliente = comprobante.razon_social;
      this.form.identificacion_cliente = comprobante.identificacion_cliente;
      this.form.detalles = [];
      this.form.numero_comprobante_afectado = comprobante.num_comp_venta;
      this.form.id_tipo_comprobante_afectado = comprobante.cod_comp_venta;
      this.form.mybillbot = comprobante.tipo === "R";
      this.form.fecha_emision_comprobante_afectado = moment(
        new Date(comprobante.fec_emi_comp_venta)
      ).format("YYYY-MM-DD");
      this.anulado = comprobante.estado === "A" ? "N" : "S";
      this.form.clave_acceso = comprobante.clave_acceso;
      this.form.numero_comprobante =
        comprobante.numero_establecimiento +
        "-" +
        comprobante.punto_emision +
        "-" +
        comprobante.numero_documento;
      this.form.fecha_emision = moment(
        new Date(comprobante.fecha_emision)
      ).format("YYYY-MM-DD");
      this.id_comprobante = comprobante.id_comprobante;
      this.estado = comprobante.estado;
      this.form.fecha_autorizacion = moment(
        new Date(comprobante.fecha_autorizacion)
      ).format("YYYY-MM-DD HH:mm");
      this.form.numero_autorizacion = comprobante.numero_autorizacion;
      this.form.detallesAdicionales = [];
      let baseImponibleIsd = 0;
      let baseImponibleIva = 0;
      let baseImponibleRenta = 0;
      for (let i = 0; i < comprobante.informacion_adicional.length; i++)
        this.form.detallesAdicionales.push({
          nombre_campo: comprobante.informacion_adicional[i].nombre,
          valor_campo: comprobante.informacion_adicional[i].valor,
        });
      this.form.detalles = [];
      for (let i = 0; i < comprobante.impuestos.length; i++) {
        if (comprobante.impuestos[i].comprobante !== null) {
          if (comprobante.impuestos[i].codigo === "2")
            baseImponibleIva = comprobante.impuestos[i].base_imponible;
          else if (comprobante.impuestos[i].codigo === "6")
            baseImponibleIsd = comprobante.impuestos[i].base_imponible;
          else baseImponibleRenta = comprobante.impuestos[i].base_imponible;
        }
        this.form.detalles.push({
          id_tarifa: comprobante.impuestos[i].codigo_porcentaje,
          base_imponible: comprobante.impuestos[i].base_imponible,
          porcentaje: comprobante.impuestos[i].tarifa,
          valor: comprobante.impuestos[i].valor,
          selectedImpuesto: comprobante.impuestos[i].impuesto,
          selectedTarifa: comprobante.impuestos[i].porcentaje,
        });
      }
      this.$modal.hide("listaComprobantes");
    },
  },
  mounted: function () {
    this.cargarDatosFormulario();
  },
  computed: {
    formatoFechaAutorizacion: function () {
      if (this.form.tipo === "E") return "yyyy-MM-dd HH:mm:ss";
      else return "yyyy-MM-dd";
    },
    tipoFechaAutorizacion: function () {
      if (this.form.tipo === "E") return "datetime";
      else return "date";
    },
    editable: function () {
      return this.estado !== "I";
    },
    isd: function () {
      let isd = 0;
      for (let i = 0; i < this.form.detalles.length; i++)
        if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoIsd
        ) {
          let valor = parseFloat(this.form.detalles[i].valor);
          if (isNaN(valor)) valor = 0;
          isd += valor;
        }
      return isd;
    },
    iva: function () {
      let iva = 0;
      for (let i = 0; i < this.form.detalles.length; i++)
        if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoIva
        ) {
          let valor = parseFloat(this.form.detalles[i].valor);
          if (isNaN(valor)) valor = 0;
          iva += valor;
        }
      return iva;
    },
    renta: function () {
      let renta = 0;
      for (let i = 0; i < this.form.detalles.length; i++)
        if (
          this.form.detalles[i].selectedTarifa !== null &&
          this.form.detalles[i].selectedTarifa.id_impuesto === this.codigoRenta
        ) {
          let valor = parseFloat(this.form.detalles[i].valor);
          if (isNaN(valor)) valor = 0;
          renta += valor;
        }
      return renta;
    },
    total: function () {
      return this.isd + this.iva + this.renta;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/compras/Retencion.vue